import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MessageCircle, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';
import { companyInfo } from '../../data/mock';

const CTASection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 p-12 md:p-16">
          {/* Background elements */}
          <div className="absolute inset-0 ai-grid-pattern opacity-10" />
          <div className="absolute top-0 right-0 w-80 h-80 bg-blue-600/20 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl" />
          
          {/* AI floating elements */}
          <div className="absolute top-10 right-10 w-20 h-20 bg-blue-600/20 rounded-2xl backdrop-blur-sm flex items-center justify-center animate-float">
            <Sparkles className="w-10 h-10 text-blue-400" />
          </div>

          <div className="relative z-10 text-center max-w-3xl mx-auto">
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-blue-600/20 text-blue-400 text-sm font-medium mb-6">
              Let's Connect
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
              Ready to Accelerate Your <span className="text-blue-400">Business Growth</span>?
            </h2>
            <p className="text-gray-400 text-lg mb-10 leading-relaxed">
              Let's discuss how PD Media's AI-powered solutions can help you achieve your business goals with proven strategies and innovative approaches.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link to="/quote">
                <Button
                  size="lg"
                  className="bg-blue-600 text-white hover:bg-blue-700 px-8 py-6 text-base font-semibold shadow-lg shadow-blue-600/25 group"
                >
                  Get a Free Quote
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
              <a href={companyInfo.whatsappLink} target="_blank" rel="noopener noreferrer">
                <Button
                  size="lg"
                  variant="outline"
                  className="border-white/20 text-white hover:bg-white/10 px-8 py-6 text-base font-semibold"
                >
                  <MessageCircle className="mr-2 w-4 h-4" />
                  Chat on WhatsApp
                </Button>
              </a>
            </div>

            {/* Trust text */}
            <p className="text-gray-500 text-sm mt-8">
              Trusted by 250+ businesses across India
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
